/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import TransactionEvent from '../../event/TransactionEvent'
import { ReservationPayState } from '../state/ReservationPayState'

class ReservationPayStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new ReservationPayState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case TransactionEvent.fetchReservation:
        // 初回ロード時
        return state.clear().set('reservation_id', payload.id)

      case TransactionEvent.onEdit:
        const names = ['accommodation_fee_paid', 'accommodation_tax_paid']
        const { name, value } = payload

        if (names.includes(name)) {
          return state.set(name, value)
        }
        return state

      default:
        return state
    }
  }
}

export default new ReservationPayStore()
